import { Directive, TemplateRef, ViewContainerRef, inject, AfterViewInit, DestroyRef } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

@Directive({ selector: '[appLocaleInvalidate]', standalone: true })
export class LocaleInvalidateDirective implements AfterViewInit {
  private vcr = inject(ViewContainerRef);
  private tpl = inject(TemplateRef<any>);
  private destroyRef = inject(DestroyRef);
  private languageService = inject(LanguageService);
  private localeChange$ = toObservable(this.languageService.locale);

  ngAfterViewInit() {
    this.vcr.createEmbeddedView(this.tpl);

    this.localeChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        setTimeout(() => {
          this.vcr.clear();
          this.vcr.createEmbeddedView(this.tpl);
        }, 0);
      });
  }
}
